/* 🤖 this file was generated by svg-to-ts */
export const matIconRemoveFromQueue: {
  name: 'remove-from-queue';
  data: string;
} = {
  name: 'remove-from-queue',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z"/></svg>`
};
